import { render, staticRenderFns } from "./ExpirationPage.vue?vue&type=template&id=359feddf&scoped=true&"
import script from "./ExpirationPage.vue?vue&type=script&lang=js&"
export * from "./ExpirationPage.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationPage.vue?vue&type=style&index=0&id=359feddf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359feddf",
  null
  
)

export default component.exports